<template>
  <span class="icons-container">
    <LATIcon icon="graduation-cap"
             :class="[completed ? 'is-completed' : 'non-completed', 'graduation-cap-icon']"
             :style="`${color?`color:${color} !important;` : ''}`"
    />
    <LATIcon v-if="!hideCheckmark" icon="check-circle"
             :class="[completed ? 'is-completed' : 'non-completed', 'check-icon']"
             :style="`${color?`color:${color} !important;` : ''}`"/>
  </span>
</template>

<script>
import LATIcon from "./LATIcon";

export default {
  name: "GraduationIcon",
  props: ['completed', 'color', 'hideCheckmark'],
  components: {LATIcon}
}
</script>

<style scoped lang="less">

@import "../../assets/lufthansacolors";

.icons-container {
  position: relative;
}

.graduation-cap-icon, .check-icon {
  color: white;
}

.graduation-cap-icon {
  width: 23px;
  height: auto;
  z-index: -10;
}

.check-icon {
  position: absolute;
  width: 15px;
  height: auto;
  top: 12px;
  left: 14px;
  z-index: 100;
  border-radius: 50%;
}

.is-completed {
  color: @lh-blue_deep;
}

.non-completed {
  color: @lh-grey-dcdcdc;
}
</style>